import React, { useState } from 'react';
import { Box, Card, CardContent } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { ReviewsTab } from './Tabs/ReviewsTab';
import { JobsTab } from './Tabs/JobsTab';
import { CampaignsTab } from './Tabs/CampaignsTab';
import { AuditionsTab } from './Tabs/AuditionsTab';
import { SalariesTab } from './Tabs/SalariesTab';
import { CultureTab } from './Tabs/CultureTab';
import { ICompanyDetails } from '../../redux/company/types';
import { MainTagCarousel } from '../EsCarousels/MainTagCarousel';

interface ICompanyTabs {
    companyDetails?: ICompanyDetails;
}

const tabLabels = [
    'Reviews',
    'Career',
    // 'Campaigns',
    'Jobs',
    //  'Salaries',
    //  'Culture'
];

const CompanyTabs: React.FC<ICompanyTabs> = ({ companyDetails }) => {
    const { themeStyle } = useThemeContext();
    const [value, setValue] = useState(tabLabels[0]);

    const handleChange = (newValue: string) => {
        setValue(newValue);
    };

    return (
        <Card
            sx={{
                backgroundColor: theme[themeStyle].secondaryBg,
                border: `1px solid ${theme[themeStyle].secondaryBg}`,
                borderRadius: 2,
            }}>
            <CardContent sx={{ p: 0 }}>
                <Box sx={{ borderBottom: 1, borderColor: theme[themeStyle].secondaryBg, px: 1 }}>
                    <MainTagCarousel
                        list={tabLabels}
                        disableTitle
                        disableViewAll
                        groupLayout
                        preselect
                        type="list"
                        onSelectTag={tag => {
                            handleChange(tag);
                        }}
                        style={{ marginTop: '10px', overflowX: 'scroll' }}
                        tagStyle={{
                            width: '100%',
                        }}
                        listStyle={{ width: '100%' }}
                    />
                </Box>

                <Box sx={{ p: 3 }}>
                    {value === 'Reviews' && <ReviewsTab companyDetails={companyDetails} />}
                    {value === 'Career' && <JobsTab companyDetails={companyDetails} />}
                    {value === 'Campaigns' && <CampaignsTab companyDetails={companyDetails} />}
                    {value === 'Jobs' && <AuditionsTab companyDetails={companyDetails} />}
                    {value === 'Salaries' && <SalariesTab companyDetails={companyDetails} />}
                    {value === 'Culture' && <CultureTab companyDetails={companyDetails} />}
                </Box>
            </CardContent>
        </Card>
    );
};

export { CompanyTabs };
